import { render, staticRenderFns } from "./NoAcceso.vue?vue&type=template&id=99c7dab4&scoped=true&"
import script from "./NoAcceso.vue?vue&type=script&lang=js&"
export * from "./NoAcceso.vue?vue&type=script&lang=js&"
import style0 from "./NoAcceso.vue?vue&type=style&index=0&id=99c7dab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c7dab4",
  null
  
)

export default component.exports